import React, { useReducer } from "react";
import {
  GET_ACCOMODATIONS,
  GET_EVENTS,
  SET_ACCOMODATION_ID,
  GET_ROOMS,
  GET_ROOMS_BY_ID,
  GET_SERVICE_POINTS,
  GET_SESSIONS,
  GET_USER_SESSIONS,
  SET_SESSION_EVENT,
  SET_LOADING,
  SET_PAGINATION,
  SET_SESSION_ID,
  GET_STATS,
  GET_RESOURCES_GROUPS,
  GET_EVENT_RESOURCES_GROUPS,
  SET_SESSION_EVENT_TITLE,
  SET_SPECIAL_ACCOMODATION,
  SET_REGULAR_ACCOMODATION,
  SET_EVENT_PAGINATION,
  GET_CENTERS,
  SET_RESOURCE_GROUP_PAGINATION,
  SET_ACCOMODATION_PAGINATION,
  GET_ACCOMODATION,
  GET_EVENT,
  SEARCH,
  GET_RESOURCE_GROUP_TYPES,
  SET_RESOURCE_GROUP_TYPE_PAGINATION,
  SET_RESOURCE_TYPE_GROUPS_PAGINATION,
  GET_RESOURCE_TYPE_GROUPS,
  SET_ROOMS_PAGINATION,
  GET_ROOM,
  SET_RESOURCE_GROUPS_VALUES,
  GET_EVENT_STATS,
  SET_USER_EMAILS,
  GET_ROOM_TYPE_VALUES,
  SELECTED_EVENT,
  GET_STATES,
  GET_COUNTRIES,
  GET_OCCUPATIONS,
  FILTER,
  SET_SEARCH_PAGINATION,
  SET_INCOME_ITEMS,
  SET_EXPENDITURE_ITEMS,
  SET_YEAR_ON_YEAR_ITEMS,
  SET_REPORTEE_ITEMS,
  SET_CENTER_PASTOR_ITEMS,
  SET_NON_COMITTED_DISCIPLES_ITEMS,
  SET_REGULAR_MEETING_ITEMS,
  SET_SPECIAL_MEETING_ITEMS,
  SET_CENTER_EXTENSION_ITEMS,
  GET_CENTER_REPORTS,
  GET_CENTER_REPORTS_PAGINATION,
  GET_CENTER_REPORT,
} from "../types";

// Original Axios import removed as it is replaced by axiosInstance
import EventContext from "./eventContext";
import EventReducer from "./eventReducer";
import storage from "../../helpers/storage";
import axiosInstance from "../../services/axios.service";
import { occupationGroups } from "../../utils/functions";
import body from "../../helpers/body";

const EventState = (props) => {
  const initialState = {
    events: [],
    event: {},
    selectedEvent: {},
    eventStats: {},
    userEmails: [],
    sessionEvent: "",
    sessionEventTitle: "",
    // sessionEventUpdate: {},
    sessionId: "",
    sessions: [],
    userSession: {},
    countries: [],
    states: [],
    search: [],
    filter: [],
    incomeItems: [],
    expenditureItems: [],
    yearOnYearItems: [],
    reporteeItems: [],
    centerPastorItems: [],
    nonComittedDisciplesItems: [],
    regularMeetingItems: [],
    specialMeetingItems: [],
    centerExtensionItems: [],
    occupations: [],
    accomodations: [],
    accomodation: {},
    accomodationId: "",
    rooms: [],
    room: {},
    roomTypeValues: [],
    regularAccomodation: {},
    specialAccomodation: {},
    accomodationRooms: [],
    resourceGroupTypes: [],
    resourceTypeGroups: [],
    resourceGroups: [],
    resourceGroupValues: [],
    eventResourceGroups: [],
    centers: [],
    centerReports: [],
    centerReport: {},
    stats: {},
    pagination: {},
    eventPagination: {},
    searchPagination: {},
    rgPagination: {},
    centerReportPagination: {},
    rTypePagination: {},
    rTypeGroupPagination: {},
    accPagination: {},
    roomsPagination: {},
    loading: false,
  };

  const [state, dispatch] = useReducer(EventReducer, initialState);
  const getCenters = async () => {
    setLoading();
    try {
      // Switched from Axios to axiosInstance
      const resp = await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/centers?limit=1000000&orderBy=title&order=asc`,
        storage.getConfigWithBearer()
      );

      dispatch({
        type: GET_CENTERS,
        payload: resp.data.data.docs,
      });
    } catch (error) {
      console.log(error);
    }
  };

  const getEvents = async (limit, page) => {
    const q = `limit=${limit}&page=${page}`;

    setLoading();
    try {
      // Switched from Axios to axiosInstance
      const resp = await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/events?${q}`,
        storage.getConfigWithBearer()
      );
      const paginate = {
        page: resp.data.data.page,
        hasNextPage: resp.data.data.hasNextPage,
        hasPreviousPage: resp.data.data.hasPreviousPage,
        nextPage: resp.data.data.nextPage,
        previousPage: resp.data.data.previousPage,
        limit: resp.data.data.limit,
        totalDocs: resp.data.data.totalDocs,
        totalPages: resp.data.data.totalPages,
      };

      dispatch({
        type: SET_EVENT_PAGINATION,
        payload: paginate,
      });

      dispatch({
        type: GET_EVENTS,
        payload: resp.data.data.docs,
      });
    } catch (error) {
      // REMOVED manual 401 check, handled by global interceptor
      console.error("Error in getEvents:", error);
    }
  };

  const getEvent = async (id) => {
    setLoading();
    try {
      // Switched from Axios to axiosInstance
      const resp = await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/events/${id}`
      );

      dispatch({
        type: GET_EVENT,
        payload: resp.data.data,
      });
    } catch (error) {
      // REMOVED manual 401 check, handled by global interceptor
      console.error("Error in getEvent:", error);
    }
  };

  /**
   * `filters` narrows the tiles the same way it narrows the list, so the
   * figures above a filtered table describe that table.
   */
  const getEventStats = async (id, filters = {}) => {
    setLoading();
    try {
      const params = new URLSearchParams();
      for (const [key, value] of Object.entries(filters)) {
        if (value !== '' && value !== null && value !== undefined) {
          params.append(key, value);
        }
      }
      const qs = params.toString();
      // Switched from Axios to axiosInstance
      const resp = await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/participants/stats/${id}${qs ? `?${qs}` : ''}`,
        storage.getConfigWithBearer()
      );

      dispatch({
        type: GET_EVENT_STATS,
        payload: resp.data.data,
      });
      // Returned as well as dispatched, so a caller that wants the numbers
      // for a local summary doesn't have to wait for a context round trip.
      return resp.data.data;
    } catch (error) {
      // REMOVED manual 401 check, handled by global interceptor
      console.error("Error in getEventStats:", error);
      return null;
    }
  };

  const searchEvent = async (limit, page, keyword) => {
    const q = `limit=${limit}&page=${page}&_keyword=${keyword}`;
    try {
      setLoading();
      // Switched from Axios to axiosInstance
      const resp = await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/events?${q}`,
        storage.getConfigWithBearer()
      );

      const paginate = {
        page: resp.data.data.page,
        hasNextPage: resp.data.data.hasNextPage,
        hasPreviousPage: resp.data.data.hasPreviousPage,
        nextPage: resp.data.data.nextPage,
        previousPage: resp.data.data.previousPage,
        limit: resp.data.data.limit,
        totalDocs: resp.data.data.totalDocs,
        totalPages: resp.data.data.totalPages,
      };

      // dispatch({
      //   type: SET_PAGINATION,
      //   payload: paginate
      // })

      // dispatch({
      //   type: SET_SEARCH_PAGINATION,
      //   payload: paginate,
      // });

      dispatch({
        type: SEARCH,
        payload: resp.data.data.docs,
      });
    } catch (error) {
      console.log(error);
    }
  };

  const setSessionId = (val) => {
    dispatch({
      type: SET_SESSION_ID,
      payload: val,
    });
  };

  const setSessionEvent = (val) => {
    setLoading();
    dispatch({
      type: SET_SESSION_EVENT,
      payload: val,
    });
  };

  // const getSessionEvent = () => {
  //   setLoading();
  //   dispatch({
  //     type: GET_SESSION_EVENT,
  //     payload: { eventId: state.sessionEvent, eventTitle: state.sessionEventTitle },
  //   });
  // };
  /**
   * One request for the participant list, whatever narrows it.
   *
   * Search and filters used to be two separate calls into two separate
   * slices of state, and paging afterwards called a third that knew about
   * neither — so moving to page 2 of a filtered list silently returned the
   * unfiltered one. Everything now goes through here, so a keyword, a set
   * of filters and a page number compose instead of overwriting each other.
   */
  const queryParticipants = async ({
    eventId,
    keyword = "",
    filters = {},
    page = 1,
    limit = 30,
    orderBy = "lastName",
    order = "asc",
  }) => {
    if (!eventId) {
      dispatch({ type: SEARCH, payload: [] });
      return { docs: [], totalDocs: 0 };
    }

    const params = new URLSearchParams();
    params.append("event", eventId);
    params.append("_page", page);
    params.append("_limit", limit);
    params.append("_orderBy", orderBy);
    params.append("_order", order);
    if (keyword) params.append("_keyword", keyword);
    for (const [key, value] of Object.entries(filters)) {
      if (value !== "" && value !== null && value !== undefined) {
        params.append(key, value);
      }
    }
    for (const field of [
      "resourceGroups",
      "room",
      "accomodation",
      "event",
      "center",
    ]) {
      params.append("_populate[]", field);
    }

    setLoading();
    try {
      const resp = await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/participants?${params.toString()}`,
        storage.getConfigWithBearer()
      );
      const data = resp.data.data;

      dispatch({
        type: SET_SEARCH_PAGINATION,
        payload: {
          page: data.page,
          hasNextPage: data.hasNextPage,
          hasPreviousPage: data.hasPreviousPage,
          nextPage: data.nextPage,
          previousPage: data.previousPage,
          limit: data.limit,
          totalDocs: data.totalDocs,
          totalPages: data.totalPages,
        },
      });
      dispatch({ type: SEARCH, payload: data.docs });
      return data;
    } catch (error) {
      console.error("Error in queryParticipants:", error);
      throw error;
    }
  };

  const clearSearch = async () => {
    dispatch({
      type: SEARCH,
      payload: [],
    });
  };

  const getAccomodations = async (eventId, limit, page) => {
    const q = `event=${eventId}&_limit=${limit}&_page=${page}&_order=asc&_orderBy=title`;
    setLoading();
    try {
      // Switched from Axios to axiosInstance
      const resp = await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/accomodations?${q}`,
        storage.getConfigWithBearer()
      );
      

      const paginate = {
        page: resp.data.data.page,
        hasNextPage: resp.data.data.hasNextPage,
        hasPreviousPage: resp.data.data.hasPreviousPage,
        nextPage: resp.data.data.nextPage,
        previousPage: resp.data.data.previousPage,
        limit: resp.data.data.limit,
        totalDocs: resp.data.data.totalDocs,
        totalPages: resp.data.data.totalPages,
      };

      dispatch({
        type: SET_ACCOMODATION_PAGINATION,
        payload: paginate,
      });
      dispatch({
        type: GET_ACCOMODATIONS,
        payload: eventId === null ? [] : resp.data.data.docs,
      });
    } catch (error) {
      // REMOVED manual 401 check, handled by global interceptor
      console.error("Error in getAccomodations:", error);
    }
  };
  const getAccomodation = async (id) => {
    setLoading();
    try {
      // Switched from Axios to axiosInstance
      const resp = await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/accomodations/${id}`,
        storage.getConfigWithBearer()
      );

      dispatch({
        type: GET_ACCOMODATION,
        payload: resp.data.data,
      });
    } catch (error) {
      // REMOVED manual 401 check, handled by global interceptor
      console.error("Error in getAccomodation:", error);
    }
  };

  // (eventId, limit, page) — matching getAccomodations, and matching what
  // most callers were already passing. The signature used to be
  // (limit, page) with no event at all, so callers passing an event id had
  // it read as a page size, and the list came back holding rooms from every
  // event in the system.
  const getRooms = async (eventId = null, limit = 100, page = 1) => {
    const q =
      `_limit=${limit}&_page=${page}&_order=asc&_orderBy=title` +
      (eventId ? `&event=${eventId}` : "");

    setLoading();

    try {
      // Switched from Axios to axiosInstance
      const resp = await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/rooms?${q}`,
        storage.getConfigWithBearer()
      );

      const paginate = {
        page: resp.data.data.page,
        hasNextPage: resp.data.data.hasNextPage,
        hasPreviousPage: resp.data.data.hasPreviousPage,
        nextPage: resp.data.data.nextPage,
        previousPage: resp.data.data.previousPage,
        limit: resp.data.data.limit,
        totalDocs: resp.data.data.totalDocs,
        totalPages: resp.data.data.totalPages,
      };

      dispatch({
        type: SET_ROOMS_PAGINATION,
        payload: paginate,
      });

      dispatch({
        type: GET_ROOMS,
        payload: resp.data.data.docs,
      });
    } catch (error) {
      // REMOVED manual 401 check, handled by global interceptor
      console.error("Error in getRooms:", error);
    }
  };

  const getRoomsByAccomodation = async (accomodationId, limit, page) => {
    const q = `accomodation=${accomodationId}&_limit=${limit}&_page=${page}&_order=asc&_orderBy=title`;

    setLoading();
    try {
      // Switched from Axios to axiosInstance
      const resp = await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/rooms?${q}`,
        storage.getConfigWithBearer()
      );

      const paginate = {
        page: resp.data.data.page,
        hasNextPage: resp.data.data.hasNextPage,
        hasPreviousPage: resp.data.data.hasPreviousPage,
        nextPage: resp.data.data.nextPage,
        previousPage: resp.data.data.previousPage,
        limit: resp.data.data.limit,
        totalDocs: resp.data.data.totalDocs,
        totalPages: resp.data.data.totalPages,
      };

      dispatch({
        type: GET_ROOMS_BY_ID,
        payload: resp.data.data.docs,
      });

      dispatch({
        type: SET_ROOMS_PAGINATION,
        payload: paginate,
      });
    } catch (error) {
      // REMOVED manual 401 check, handled by global interceptor
      console.error("Error in getRoomsByAccomodation:", error);
    }
  };

  const getRoom = async (roomId) => {
    setLoading();
    try {
      // Switched from Axios to axiosInstance
      const resp = await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/rooms/${roomId}`,
        storage.getConfigWithBearer()
      );
      // The room's criteria used to be flattened into `roomTypeValues` for
      // a picker that no longer exists; nothing has read it since, and the
      // room form works from the record itself.
      dispatch({
        type: GET_ROOM,
        payload: resp.data.data,
      });
    } catch (error) {
      // REMOVED manual 401 check, handled by global interceptor
      console.error("Error in getRoom:", error);
    }
  };

  // `eventId` narrows the list to one event — Event setup shows the
  // sessions of the event being set up, not every session in the system.
  /**
   * Where everybody would be assigned, without assigning them.
   *
   * Read straight out rather than into context: it is a one-off answer
   * for one screen, and stale numbers here would be worse than none —
   * people register between one run and the next.
   */
  const previewAssignments = async (eventId) => {
    try {
      const resp = await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/events/${eventId}/assignment-preview`,
        storage.getConfigWithBearer()
      );
      return { success: true, data: resp.data.data ?? resp.data };
    } catch (error) {
      return { success: false, error };
    }
  };

  const getSessions = async (limit, page, eventId = null) => {
    const q =
      `_limit=${limit}&_page=${page}&_populate=event` +
      (eventId ? `&event=${eventId}` : "");
    try {
      // Switched from Axios to axiosInstance
      const resp = await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/sessions?${q}`,
        storage.getConfigWithBearer()
      );

      const paginate = {
        page: resp.data.data.page,
        hasNextPage: resp.data.data.hasNextPage,
        hasPreviousPage: resp.data.data.hasPreviousPage,
        nextPage: resp.data.data.nextPage,
        previousPage: resp.data.data.previousPage,
        limit: resp.data.data.limit,
        totalDocs: resp.data.data.totalDocs,
        totalPages: resp.data.data.totalPages,
      };

      dispatch({
        type: SET_PAGINATION,
        payload: paginate,
      });

      dispatch({
        type: GET_SESSIONS,
        payload: resp.data.data.docs,
      });

      setSessionId(resp.data.data.docs[0]._id);
      // setSessionEvent(resp.data.data.docs[0].event._id);
      // setSessionEventTitle(resp.data.data.docs[0].event.title);
      // setSpecialAccomodation(resp.data.data.docs[0].event._id);
      // setRegularAccomodation(resp.data.data.docs[0].event._id);
      // getParticipants(resp.data.data.docs[0].event._id);
      // getAccomodations(resp.data.data.docs[0].event._id);
      // getResourceGroups(resp.data.data.docs[0].event._id);
    } catch (error) {
      // REMOVED manual 401 check, handled by global interceptor
      console.error("Error in getSessions:", error);
    }
  };

  const getUserSession = async () => {
    try {
      // Switched from Axios to axiosInstance
      const resp = await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/sessions`,
        storage.getConfigWithBearer()
      );
      dispatch({
        type: GET_USER_SESSIONS,
        payload: resp.data.data.docs[0],
      });
    } catch (error) {
      // REMOVED manual 401 check, handled by global interceptor
      console.error("Error in getUserSession:", error);
    }
  };

  const getAccomodationId = (val) => {
    dispatch({
      type: SET_ACCOMODATION_ID,
      payload: val,
    });
  };

  const getResourceGroups = async (limit, page) => {
    const q = `limit=${limit}&page=${page}&_populate=type&_populate=event&_order=asc&_orderBy=title`;
    setLoading();
    try {
      // Switched from Axios to axiosInstance
      const resp = await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/resource-groups?${q}`,
        storage.getConfigWithBearer()
      );

      const paginate = {
        page: resp.data.data.page,
        hasNextPage: resp.data.data.hasNextPage,
        hasPreviousPage: resp.data.data.hasPreviousPage,
        nextPage: resp.data.data.nextPage,
        previousPage: resp.data.data.previousPage,
        limit: resp.data.data.limit,
        totalDocs: resp.data.data.totalDocs,
        totalPages: resp.data.data.totalPages,
      };

      dispatch({
        type: SET_RESOURCE_GROUP_PAGINATION,
        payload: paginate,
      });

      dispatch({
        type: GET_RESOURCES_GROUPS,
        payload: resp.data.data.docs,
      });
    } catch (error) {
      // REMOVED manual 401 check, handled by global interceptor
      console.error("Error in getResourceGroups:", error);
    }
  };
  // Types are a shared catalog — "Prayer Cell" means the same thing at every
  // event — so this is not scoped to one. It used to filter by event, which
  // meant the same convention had to be re-created for each new event and
  // the names drifted apart between copies.
  const getResourceGroupTypes = async (limit, page) => {
    const q = `limit=${limit}&page=${page}&_order=asc&_orderBy=title`;

    setLoading();

    try {
      // Switched from Axios to axiosInstance
      const resp = await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/resource-group-types?${q}&_populate=createdBy`,
        storage.getConfigWithBearer()
      );

      const paginate = {
        page: resp.data.data.page,
        hasNextPage: resp.data.data.hasNextPage,
        hasPreviousPage: resp.data.data.hasPreviousPage,
        nextPage: resp.data.data.nextPage,
        previousPage: resp.data.data.previousPage,
        limit: resp.data.data.limit,
        totalDocs: resp.data.data.totalDocs,
        totalPages: resp.data.data.totalPages,
      };

      dispatch({
        type: SET_RESOURCE_GROUP_TYPE_PAGINATION,
        payload: paginate,
      });

      dispatch({
        type: GET_RESOURCE_GROUP_TYPES,
        payload: resp.data.data.docs,
      });
    } catch (error) {
      // REMOVED manual 401 check, handled by global interceptor
      console.error("Error in getResourceGroupTypes:", error);
    }
  };

  const getEventResourceGroups = async (eventId, limit, page) => {
    const q = `limit=${limit}&page=${page}&_populate=type&_populate=event&_order=asc&_orderBy=title`;

    setLoading();
    try {
      // Switched from Axios to axiosInstance
      const resp = await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/resource-groups?event=${eventId}&${q}`,
        storage.getConfigWithBearer()
      );

      const paginate = {
        page: resp.data.data.page,
        hasNextPage: resp.data.data.hasNextPage,
        hasPreviousPage: resp.data.data.hasPreviousPage,
        nextPage: resp.data.data.nextPage,
        previousPage: resp.data.data.previousPage,
        limit: resp.data.data.limit,
        totalDocs: resp.data.data.totalDocs,
        totalPages: resp.data.data.totalPages,
      };

      dispatch({
        type: SET_RESOURCE_GROUP_PAGINATION,
        payload: paginate,
      });

      dispatch({
        type: GET_EVENT_RESOURCES_GROUPS,
        payload: eventId === null ? [] : resp.data.data.docs,
      });
    } catch (error) {
      // REMOVED manual 401 check, handled by global interceptor
      console.error("Error in getEventResourceGroups:", error);
    }
  };

  const getStats = async () => {
    setLoading();

    try {
      // Switched from Axios to axiosInstance
      const resp = await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/misc/dashboard-stats`,
        storage.getConfigWithBearer()
      );
      dispatch({
        type: GET_STATS,
        payload: resp.data.data,
      });
    } catch (error) {
      // REMOVED manual 401 check, handled by global interceptor
      if (error && error.response) {
        console.error("Error in getStats:", error.response);
      }
    }
  };

  const setUserEmails = (data) => {
    let result = [];

    const emails = data?.forEach((x) => {
      return result.push(x?.email);
    });
    dispatch({
      type: SET_USER_EMAILS,
      payload: result,
    });
  };

  const setLoading = () => {
    dispatch({
      type: SET_LOADING,
    });
  };

  const getOccupations = (data) => {
    dispatch({
      type: GET_OCCUPATIONS,
      payload: occupationGroups(),
    });
  };

  /**
   * Every participant matching a query, not just a page of them.
   *
   * A bulk action offered over a filtered list of 607 could only ever
   * reach the 30 on screen, because the selection was built from the rows
   * that had been rendered. This walks the pages instead.
   *
   * The API caps a page at 1,000 however large a limit is asked for, so
   * this pages rather than asking for everything at once — an event that
   * outgrows one page must not silently send to the first thousand.
   */
  const fetchAllParticipants = async ({
    eventId,
    keyword = "",
    filters = {},
    orderBy = "lastName",
    order = "asc",
  }) => {
    if (!eventId) return [];

    const PAGE = 1000;
    const all = [];
    let page = 1;

    for (;;) {
      const params = new URLSearchParams();
      params.append("event", eventId);
      params.append("_page", page);
      params.append("_limit", PAGE);
      params.append("_orderBy", orderBy);
      params.append("_order", order);
      if (keyword) params.append("_keyword", keyword);
      for (const [key, value] of Object.entries(filters)) {
        if (value !== "" && value !== null && value !== undefined) {
          params.append(key, value);
        }
      }

      const resp = await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/participants?${params.toString()}`,
        storage.getConfigWithBearer()
      );
      const data = resp.data.data;
      all.push(...(data.docs ?? []));

      if (!data.hasNextPage || !(data.docs ?? []).length) break;
      page += 1;
    }

    return all;
  };

  const setSelectedEvent = (data) => {
    dispatch({
      type: SELECTED_EVENT,
      payload: data,
    });
  };
  const setStates = (data) => {
    dispatch({
      type: GET_STATES,
      payload: data,
    });
  };

  const getCenterReports = async (limit, page) => {
    const q = `limit=${limit}&page=${page}&_populate=center`;
    setLoading();
    try {
      // Switched from Axios to axiosInstance
      const resp = await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/center-reports?${q}`,
        storage.getConfigWithBearer()
      );

      const paginate = {
        page: resp.data.data.page,
        hasNextPage: resp.data.data.hasNextPage,
        hasPreviousPage: resp.data.data.hasPreviousPage,
        nextPage: resp.data.data.nextPage,
        previousPage: resp.data.data.previousPage,
        limit: resp.data.data.limit,
        totalDocs: resp.data.data.totalDocs,
        totalPages: resp.data.data.totalPages,
      };

      dispatch({
        type: GET_CENTER_REPORTS_PAGINATION,
        payload: paginate,
      });

      dispatch({
        type: GET_CENTER_REPORTS,
        payload: resp.data.data.docs,
      });
    } catch (error) {
      // REMOVED manual 401 check, handled by global interceptor
      console.error("Error in getCenterReports:", error);
    }
  };

  const getCenterReport = async (id) => {
    const q = `_populate=center`;
    setLoading();
    try {
      // Switched from Axios to axiosInstance
      const resp = await axiosInstance.get(
        `${process.env.REACT_APP_BASE_URL}/center-reports/${id}?${q}`,
        storage.getConfigWithBearer()
      );

      if (
        resp.data.data.incomeBreakdown &&
        resp.data.data.incomeBreakdown.length > 0
      ) {
        const formatted = resp.data.data.incomeBreakdown.map((item) => ({
          label: body.generate(6, true).toUpperCase(),
          name: typeof item === "string" ? item : item.name || "",
          amount: parseFloat(item.amount || 0),
        }));
        setItems("income", formatted);
      } else {
        let incomeItem = {
          label: body.generate(6, true).toUpperCase(),
          name: "",
          amount: 0,
        };
        setItems("income", [incomeItem]);
      }

      if (
        resp.data.data.expenditureBreakdown &&
        resp.data.data.expenditureBreakdown.length > 0
      ) {
        const formatted = resp.data.data.expenditureBreakdown.map((item) => ({
          label: body.generate(6, true).toUpperCase(),
          name: typeof item === "string" ? item : item.name || "",
          amount: parseFloat(item.amount || 0),
        }));
        setItems("expenditure", formatted);
      } else {
        let expenditureItem = {
          label: body.generate(6, true).toUpperCase(),
          name: "",
          amount: 0,
        };
        setItems("expenditure", [expenditureItem]);
      }

      if (
        resp.data.data.yearOnYearBreakdown &&
        resp.data.data.yearOnYearBreakdown.length > 0
      ) {
        const formatted = resp.data.data.yearOnYearBreakdown.map((item) => ({
          label: body.generate(6, true).toUpperCase(),
          name: typeof item === "string" ? item : item.name || "",
          amount: parseFloat(item.amount || 0),
          year: item.year || "",
        }));
        setItems("yearOnYear", formatted);
      } else {
        let yearOnYearItem = {
          label: body.generate(6, true).toUpperCase(),
          name: "",
          amount: 0,
          year: "",
        };
        setItems("yearOnYear", [yearOnYearItem]);
      }

      if (
        resp.data.data.centerExtensions &&
        resp.data.data.centerExtensions.length > 0
      ) {
        const formatted = resp.data.data.centerExtensions.map((item) => ({
          label: body.generate(6, true).toUpperCase(),
          name: typeof item === "string" ? item : item.name || "",
        }));
        setItems("centerExtension", formatted);
      } else {
        let centerExtensionItem = {
          label: body.generate(6, true).toUpperCase(),
          name: "",
        };
        setItems("centerExtension", [centerExtensionItem]);
      }

      if (
        resp.data.data.centerRegularMeetings &&
        resp.data.data.centerRegularMeetings.length > 0
      ) {
        const formattedMeetings = resp.data.data.centerRegularMeetings.map(
          (item) => ({
            label: body.generate(6, true).toUpperCase(),
            name: typeof item === "string" ? item : item.name || "",
          })
        );

        setItems("regularMeeting", formattedMeetings);
      } else {
        let regularItem = {
          label: body.generate(6, true).toUpperCase(),
          name: "",
        };
        setItems("regularMeeting", [regularItem]);
      }

      if (
        resp.data.data.centerSpecialMeetings &&
        resp.data.data.centerSpecialMeetings.length > 0
      ) {
        const formatted = resp.data.data.centerSpecialMeetings.map((item) => ({
          label: body.generate(6, true).toUpperCase(),
          name: typeof item === "string" ? item : item.name || "",
        }));
        setItems("specialMeeting", formatted);
      } else {
        let specialItem = {
          label: body.generate(6, true).toUpperCase(),
          name: "",
        };
        setItems("specialMeeting", [specialItem]);
      }

      if (
        resp.data.data.reasonsForNonComittedDisciples &&
        resp.data.data.reasonsForNonComittedDisciples.length > 0
      ) {
        const formatted = resp.data.data.reasonsForNonComittedDisciples.map(
          (item) => ({
            label: body.generate(6, true).toUpperCase(),
            name: typeof item === "string" ? item : item.name || "",
          })
        );
        setItems("nonComittedDisciples", formatted);
      } else {
        let nonComittedItem = {
          label: body.generate(6, true).toUpperCase(),
          name: "",
        };
        setItems("nonComittedDisciples", [nonComittedItem]);
      }

      if (resp.data.data.reportees && resp.data.data.reportees.length > 0) {
        const formatted = resp.data.data.reportees.map((item) => ({
          label: body.generate(6, true).toUpperCase(),
          name: typeof item === "string" ? item : item.name || "",
          date: typeof item === "string" ? item : item.date || "",
        }));
        setItems("reportee", formatted);
      } else {
        let reporteeItem = {
          label: body.generate(6, true).toUpperCase(),
          name: "",
          date: "",
        };
        setItems("reportee", [reporteeItem]);
      }

      if (
        resp.data.data.centerPastors &&
        resp.data.data.centerPastors.length > 0
      ) {
        const formatted = resp.data.data.centerPastors.map((item) => ({
          label: body.generate(6, true).toUpperCase(),
          name: typeof item === "string" ? item : item.name || "",
          date: typeof item === "string" ? item : item.date || "",
        }));
        setItems("centerPastor", formatted);
      } else {
        let centerPastorItem = {
          label: body.generate(6, true).toUpperCase(),
          name: "",
          date: "",
        };
        setItems("centerPastor", [centerPastorItem]);
      }

      dispatch({
        type: GET_CENTER_REPORT,
        payload: resp.data.data,
      });
    } catch (error) {
      // REMOVED manual 401 check, handled by global interceptor
      console.error("Error in getCenterReport:", error);
    }
  };

  const setItems = (type, data) => {
    if (type === "income") {
      dispatch({
        type: SET_INCOME_ITEMS,
        payload: data,
      });
    }

    if (type === "expenditure")
      dispatch({
        type: SET_EXPENDITURE_ITEMS,
        payload: data,
      });

    if (type === "yearOnYear")
      dispatch({
        type: SET_YEAR_ON_YEAR_ITEMS,
        payload: data,
      });

    if (type === "reportee")
      dispatch({
        type: SET_REPORTEE_ITEMS,
        payload: data,
      });

    if (type === "centerPastor")
      dispatch({
        type: SET_CENTER_PASTOR_ITEMS,
        payload: data,
      });

    if (type === "nonComittedDisciples")
      dispatch({
        type: SET_NON_COMITTED_DISCIPLES_ITEMS,
        payload: data,
      });

    if (type === "regularMeeting")
      dispatch({
        type: SET_REGULAR_MEETING_ITEMS,
        payload: data,
      });

    if (type === "specialMeeting")
      dispatch({
        type: SET_SPECIAL_MEETING_ITEMS,
        payload: data,
      });

    if (type === "centerExtension")
      dispatch({
        type: SET_CENTER_EXTENSION_ITEMS,
        payload: data,
      });
  };

  return (
    <EventContext.Provider
      value={{
        incomeItems: state.incomeItems,
        expenditureItems: state.expenditureItems,
        yearOnYearItems: state.yearOnYearItems,
        reporteeItems: state.reporteeItems,
        centerPastorItems: state.centerPastorItems,
        nonComittedDisciplesItems: state.nonComittedDisciplesItems,
        regularMeetingItems: state.regularMeetingItems,
        specialMeetingItems: state.specialMeetingItems,
        centerExtensionItems: state.centerExtensionItems,
        events: state.events,
        event: state.event,
        selectedEvent: state.selectedEvent,
        eventStats: state.eventStats,
        centers: state.centers,
        centerReports: state.centerReports,
        centerReport: state.centerReport,
        countries: state.countries,
        states: state.states,
        sessionEvent: state.sessionEvent,
        // sessionEventUpdate: state.sessionEventUpdate,
        sessionEventTitle: state.sessionEventTitle,
        sessionId: state.sessionId,
        sessions: state.sessions,
        userEmails: state.userEmails,
        userSession: state.userSession,
        pagination: state.pagination,
        eventPagination: state.eventPagination,
        searchPagination: state.searchPagination,
        rTypePagination: state.rTypePagination,
        rTypeGroupPagination: state.rTypeGroupPagination,
        rgPagination: state.rgPagination,
        centerReportPagination: state.centerReportPagination,
        accPagination: state.accPagination,
        roomsPagination: state.roomsPagination,
        search: state.search,
        occupations: state.occupations,
        accomodations: state.accomodations,
        accomodation: state.accomodation,
        regularAccomodation: state.regularAccomodation,
        specialAccomodation: state.specialAccomodation,
        rooms: state.rooms,
        room: state.room,
        roomTypeValues: state.roomTypeValues,
        accomodationRooms: state.accomodationRooms,
        accomodationId: state.accomodationId,
        resourceGroupTypes: state.resourceGroupTypes,
        resourceTypeGroups: state.resourceTypeGroups,
        resourceGroups: state.resourceGroups,
        resourceGroupValues: state.resourceGroupValues,
        eventResourceGroups: state.eventResourceGroups,
        stats: state.stats,
        loading: state.loading,
        getEvents,
        getEvent,
        getEventStats,
        searchEvent,
        getCenters,
        setSessionEvent,
        // getSessionEvent,
        getSessions,
        previewAssignments,
        setSessionId,
        getUserSession,
        queryParticipants,
        fetchAllParticipants,
        // setPagination,
        clearSearch,
        getOccupations,
        getAccomodations,
        getAccomodation,
        getRooms,
        getRoom,
        getRoomsByAccomodation,
        getAccomodationId,
        getEventResourceGroups,
        getResourceGroupTypes,
        getResourceGroups,
        getStats,
        setUserEmails,
        setSelectedEvent,
        setStates,
        setItems,
        getCenterReports,
        getCenterReport,
      }}
    >
      {props.children}
    </EventContext.Provider>
  );
};

export default EventState;
